
import { Options, Prop, Vue } from 'vue-property-decorator';

@Options({})
export default class VideoWallPageSidebarSection extends Vue {
  @Prop({ required: true, type: String })
  readonly header!: string;
}
